import React from 'react'

import EstimationActions from '../libs/EstimationActions'

import Autosuggest from 'react-autosuggest'
import OneLineEditor from './OneLineEditor'
import Utils from '../libs/Utils'

class OneLineEditorWithSuggestion extends OneLineEditor {
  constructor (props) {
    super(props)
    this.state = {
      id: Utils.uuid('OneLineEditorWithSuggestion'),
      value: '',
      suggestions: [],
      textAlign: this.props.textAlign,
      bindingDataAttribute: this.props.bindingDataAttribute,
      data: this.props.getData(),
      listener: null
    }
  }

  onFocus (event) {
    const target = event.target
    const val = target.value
    target.value = null
    target.focus()
    target.value = val
  }

  onChange (event, { newValue, method }) {
    let changedValue = newValue
    // 空文字のみの場合は、値をnullとする(DynamoDBの対策)
    if (changedValue.match(/^[\s:blank:]*$/)) {
      changedValue = null
    }
    if (this.props.isList) {
      let listName = this.props.listName
      let index = this.props.index
      this.props.setListData(listName, index, this.state.bindingDataAttribute, changedValue, this.props.callback)
    } else {
      this.props.setFlatData(this.state.bindingDataAttribute, changedValue, this.props.callback)
    }
    this.setState({
      value: newValue
    })
  };

  onSuggestionsFetchRequested ({ value }) {
    this.setState({
      suggestions: this.getSuggestions(value)
    })
  }

  onSuggestionsClearRequested () {
    this.setState({
      suggestions: []
    })
  }

  escapeRegexCharacters (str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  }

  getSuggestions (value) {
    const escapedValue = this.escapeRegexCharacters(value.trim())
    const regex = new RegExp('' + escapedValue, 'i')

    return this.props.options.filter(language => regex.test(language.name))
  }

  getSuggestionValue (suggestion) {
    return suggestion.name
  }

  shouldRenderSuggestions () {
    return true
  }

  renderSuggestion (suggestion) {
    return (
      <span>{suggestion.name}</span>
    )
  }

  storeInputReference (autosuggest) {
    if (autosuggest !== null) {
      this.input = autosuggest.input
      this.input.focus()
    }
  }
  render () {
    const suggestions = this.state.suggestions
    const value = this.getDataValue() ? this.getDataValue() : ''
    const inputProps = {
      id: this.state.id,
      placeholder: '',
      value,
      onChange: this.onChange.bind(this),
      onBlur: this.exitEditingMode.bind(this),
      onKeyDown: this.exitEditingModeIfEnterKey.bind(this),
      onFocus: this.onFocus.bind(this)
    }
    const theme = {
      container: {
        position: 'relative'
      },
      input: {
        width: '99%',
        height: 20,
        margin: 0,
        padding: 0,
        fontSize: '14px',
        border: '1px solid #ccc',
        textAlign: this.props.textAlign
      },
      inputFocused: {
        outline: 'none'
      },
      inputOpen: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      },
      suggestionsContainer: {
        display: 'none'
      },
      suggestionsContainerOpen: {
        display: 'block',
        position: 'absolute',
        top: 21,
        width: '99%',
        border: '1px solid #aaa',
        backgroundColor: '#fff',
        fontSize: 14,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 2
      },
      suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none'
      },
      suggestion: {
        cursor: 'pointer',
        padding: 0,
        fontSize: 14
      },
      suggestionHighlighted: {
        backgroundColor: '#ddd'
      }
    }
    return (
      <div>
        {this.isEditing()
          ? <div>
            <Autosuggest
              suggestions={suggestions}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this)}
              getSuggestionValue={this.getSuggestionValue.bind(this)}
              shouldRenderSuggestions={this.shouldRenderSuggestions.bind(this)}
              renderSuggestion={this.renderSuggestion}
              inputProps={inputProps}
              ref={this.storeInputReference.bind(this)}
              theme={theme}
            />
          </div>
        : <div onClick={this.enterEditingMode.bind(this)}
          className='kw-w99'>{this.getFormattedValue()}</div>
        }
      </div>
    )
  }
}

OneLineEditorWithSuggestion.defaultProps = {options: [], textAlign: 'left', isList: false, isEditable: true, getData: EstimationActions.getCurrentEstimation, setListData: EstimationActions.updateListInCurrentEstimation, setFlatData: EstimationActions.updateCurrentEstimation}

export default OneLineEditorWithSuggestion



// WEBPACK FOOTER //
// ./src/company_user/components/OneLineEditorWithSuggestion.js